<template>
  <v-dialog v-model="openDialog" width="400">
    <v-card>
      <v-layout row wrap class="pr-1 pt-1">
        <v-spacer />
        <v-icon large color="error" @click="openDialog = false">close</v-icon>
      </v-layout>
      <v-layout row wrap v-if="filterOptions" class="px-4 pb-2">
        <v-flex
          xs12
          v-for="(option, index) in Object.keys(filterOptions)"
          :key="index"
        >
          <v-autocomplete
            v-model="filters[`${option}_id`]"
            :items="filterOptions[option]"
            item-text="title"
            item-value="id"
            :label="makeLabel(option)"
            persistent-hint
            style="text-transform: capitalize"
            @change="$emit('filter', filters)"
            clearable
          ></v-autocomplete>
        </v-flex>
        <!-- <v-btn color="success" @click="resetFilter">Reset</v-btn> -->

        <v-btn class="mx-0" color="success" @click="$emit('apply')">
          Apply
        </v-btn>
      </v-layout>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    props: ["filterOptions", "value", "filterTypes"],
    data() {
      return {
        openDialog: this.value,
        filters: {},
      };
    },
    watch: {
      value() {
        this.openDialog = this.value;
      },
      openDialog() {
        this.$emit("input", this.openDialog);
      },
      filterTypes() {
        this.filters = { ...this.filterTypes };
      },
    },
    methods: {
      makeLabel(label) {
        return label.split("_").join(" ");
      },
    },
  };
</script>
